module.exports = __webpack_public_path__ + "img/pg5_individualization.7f84b9fe.png";